// extracted by mini-css-extract-plugin
export default {"dialog":"ConfirmDialog_dialog__cA7Bc","title":"ConfirmDialog_title__yNzQO","message":"ConfirmDialog_message__f3y4A","destructiveBtn":"ConfirmDialog_destructiveBtn__hc+g-"};